import { WatchQueryFetchPolicy } from '@apollo/client';

import { ActivitiesFontSize, LanguageCodes } from 'global/constants';
import { useActivityBuilderTheme } from '../theme/activity-builder-theme';
import useUserData from 'approot/shared/user/user-data';
import { useGetPublishedAssessmentActivitiesByVersion } from '../graphql/use-get-published-assessment-activities-by-version';
import { useGetDraftAssessmentActivities } from '../graphql/use-get-draft-assessment-activities';

type GetInteractiveProps = {
  contentId?: number;
  classId: number | null;
  version?: string;
  fetchPolicy?: WatchQueryFetchPolicy;
  skip?: boolean;
  language?: LanguageCodes;
};

export const useGetAssessmentActivities = ({
  contentId,
  classId,
  version,
  fetchPolicy = 'cache-first',
  skip,
  language,
}: GetInteractiveProps) => {
  const { isSignedIn } = useUserData();
  const { updateFontSize } = useActivityBuilderTheme();

  const {
    data: draftData,
    loading,
    error,
  } = useGetDraftAssessmentActivities({
    contentId,
    skip: !!(version || !contentId || skip),
    language,
  });

  const {
    data: publishedData,
    loading: publishedLoading,
    error: publishedError,
  } = useGetPublishedAssessmentActivitiesByVersion({
    skip: !version || skip,
    fetchPolicy,
    isSignedIn,
    classId,
    version: version || '',
    language,
    onCompleted: res => {
      if (res.getPublishedAssessmentActivitiesByVersion.styles) {
        updateFontSize(
          res.getPublishedAssessmentActivitiesByVersion.styles
            .fontSize as ActivitiesFontSize
        );
      }
    },
  });

  return {
    data: version
      ? publishedData?.getPublishedAssessmentActivitiesByVersion
      : draftData,
    loading: version ? publishedLoading : loading,
    error: version ? publishedError : error,
  };
};
